export const CHARACTER_IDS = [
  'iroha',
  'yachiyo',
  'sana',
  'tsuruno',
  'felicia',
  'kuroe',
];

export const createEmptyEyeCatchCounter = () => ({
  iroha: { strong: 0, weak: 0 },
  yachiyo: { strong: 0, weak: 0 },
  sana: { strong: 0, weak: 0 },
  tsuruno: { strong: 0, weak: 0 },
  felicia: { strong: 0, weak: 0 },
  kuroe: { strong: 0, weak: 0 },
});

export const createEmptyLap = () => ({
  lapId: Math.random().toString(36).substr(2, 9),
  createdAt: new Date().toISOString(),
  suikaCount: 0,
  czCount: 0,
  eyeCatches: createEmptyEyeCatchCounter(),
  bonusType: 'bb', // 'bb' or 'at'
  excludeFromStats: false, // スイカ/CZを統計から除外するかどうか
});

export const createEmptyToolData = () => ({
  total: {
    suikaCount: 0,
    czCount: 0,
  },
  laps: [],
});